import { Dispatch, SetStateAction } from 'react'
import { Badge, Box, Flex, HStack, IconButton, Stack, Text } from '@chakra-ui/react'

import { CustomFormScoreClassification } from 'components/tools/CustomForm/types'
import { Close } from 'components/icons'
import ScoreClassificationIntervalForm from './components/ScoreClassificationIntervalForm'

type Props = {
  classificationIndex: number
  classifications: CustomFormScoreClassification[]
  classification: CustomFormScoreClassification
  setClassifications: Dispatch<SetStateAction<CustomFormScoreClassification[]>>
}

export default function ScoreClassificationIntervalItems({
  classifications,
  classification,
  classificationIndex,
  setClassifications,
}: Props) {
  function removeInterval() {
    const updatedIntervals = classifications.filter((_, index) => {
      return classificationIndex !== index
    })
    setClassifications(updatedIntervals)
  }

  return (
    <Stack spacing={4}>
      <Flex align="center" justify="space-between" gap={2}>
        <Box width="30%">
          <Badge width="max-content" colorScheme={classification.color || 'gray'} variant="solid">
            {classification.tag || 'Sem nome'}
          </Badge>
        </Box>

        <Flex width="40%" align="center" justify="center" gap={2}>
          {classification.condition === 'BIGGER_THAN' && <Text>{`>= ${classification.from}`}</Text>}
          {classification.condition === 'LOWER_THAN' && <Text>{`<= ${classification.to}`}</Text>}
          {classification.condition === 'INTERVAL' && <Text>{`${classification.from} - ${classification.to} `}</Text>}
          {classification.condition === 'EQUAL' && <Text>{`Igual a ${classification.from} `}</Text>}
        </Flex>

        <HStack width="30%" justify="flex-end">
          <ScoreClassificationIntervalForm
            classification={classification}
            classificationIndex={classificationIndex}
            setClassifications={setClassifications}
          />

          <IconButton
            onClick={removeInterval}
            variant="ghost"
            colorScheme="red"
            aria-label="remover classificação"
            icon={<Close boxSize={8} />}
          />
        </HStack>
      </Flex>
    </Stack>
  )
}
